import React from 'react'
import Heading from 'constructicon/heading'
import LoginForm from 'supporticon/components/login-form'

const Everydayhero = ({ onSuccess }) => (
  <div>
    <Heading>Login to your account</Heading>
    <LoginForm
      clientId={process.env.EDH_CLIENT_ID}
      onSuccess={onSuccess}
    />
  </div>
)

export default Everydayhero
